<template>
  <div>
    <main-header/>
    <div id="main-container">
      <!--
      <div>
        <main-menu/>
      </div>
      -->
      <div id="wrapper" >
        <div id="router-view">
          <router-view  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue';
//import MainMenu from './MainMenu.vue';
//import Footer from './Footer.vue';

export default {
  name: 'MainLayout',
  components: {
    //'main-menu': MainMenu,
    'main-header': Header,
    //'main-footer': Footer,
  },
  mounted() {
    document.getElementById('app').classList.remove('login');
  },
  data() {
    return {
      wrapper: '',
    };
  },
  watch: {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
